(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1391],{

/***/ 20133:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/info/pools/[address]",
      function () {
        return __webpack_require__(15542);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 53629:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ NextLinkFromReactRouter; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(94589);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);




function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var A = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].a.withConfig */ .ZP.a.withConfig({
    componentId: "sc-a01cb22d-0"
})(_templateObject());
/**
 * temporary solution for migrating React Router to Next.js Link
 */ var NextLinkFromReactRouter = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.forwardRef)(function(_param, ref) /*#__PURE__*/ {
    var to = _param.to, replace = _param.replace, children = _param.children, prefetch = _param.prefetch, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_param, [
        "to",
        "replace",
        "children",
        "prefetch"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
        href: to,
        replace: replace,
        passHref: true,
        prefetch: prefetch,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(A, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
            ref: ref
        }, props), {
            children: children
        }))
    });
});


/***/ }),

/***/ 15542:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _address_; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/views/Info/index.tsx + 1 modules
var Info = __webpack_require__(91261);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Flex.tsx
var Flex = __webpack_require__(4318);
// EXTERNAL MODULE: ./packages/uikit/src/components/Button/Button.tsx + 2 modules
var Button = __webpack_require__(96293);
// EXTERNAL MODULE: ./packages/uikit/src/contexts/MatchBreakpoints/useMatchBreakpoints.ts
var useMatchBreakpoints = __webpack_require__(25349);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/Close.tsx
var Close = __webpack_require__(92510);
// EXTERNAL MODULE: ./packages/uikit/src/components/Text/Text.tsx
var Text = __webpack_require__(97114);
// EXTERNAL MODULE: ./packages/uikit/src/components/Link/LinkExternal.tsx
var LinkExternal = __webpack_require__(10566);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Box.tsx
var Box = __webpack_require__(44850);
// EXTERNAL MODULE: ./packages/uikit/src/components/Card/Card.tsx + 1 modules
var Card = __webpack_require__(38144);
// EXTERNAL MODULE: ./packages/uikit/src/components/Heading/Heading.tsx + 1 modules
var Heading = __webpack_require__(59750);
// EXTERNAL MODULE: ./src/components/Layout/Page.tsx + 2 modules
var Page = __webpack_require__(89491);
// EXTERNAL MODULE: ./src/components/NextLink.tsx
var NextLink = __webpack_require__(53629);
// EXTERNAL MODULE: ./packages/localization/src/index.tsx + 4 modules
var src = __webpack_require__(65208);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/state/info/hooks.ts
var hooks = __webpack_require__(4897);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(94589);
// EXTERNAL MODULE: ./src/utils/index.ts
var utils = __webpack_require__(93293);
// EXTERNAL MODULE: ./src/views/Info/components/CurrencyLogo/index.tsx + 1 modules
var CurrencyLogo = __webpack_require__(60764);
// EXTERNAL MODULE: ./src/views/Info/components/InfoCharts/LineChart/index.tsx
var LineChart = __webpack_require__(45091);
// EXTERNAL MODULE: ./src/views/Info/components/InfoCharts/BarChart/index.tsx
var BarChart = __webpack_require__(55224);
// EXTERNAL MODULE: ./src/utils/formatInfoNumbers.ts
var formatInfoNumbers = __webpack_require__(56245);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/fromUnixTime/index.js
var fromUnixTime = __webpack_require__(42227);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./src/views/Info/components/InfoCharts/ChartCard/index.tsx
/* eslint-disable */ 
function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 10px 12px;\n  font-weight: 400;\n  margin-right: 10px;\n  font-size: 14px;\n  color: #000;\n  opacity: 1 !important;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  cursor: pointer;\n  background: ",
        ";\n  border-width: 1px;\n  border-style: solid;\n  font-size: 14px;\n  padding: ",
        ";\n  /* padding: 5px 10px; */\n  border-radius: 6px;\n  border-color: ",
        ";\n  margin-right: 10px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}










var CandleChart = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(3136), __webpack_require__.e(5491)]).then(__webpack_require__.bind(__webpack_require__, 85491));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(85491)
            ];
        }
    },
    ssr: false
});
var KlineChart = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(2655), __webpack_require__.e(7448)]).then(__webpack_require__.bind(__webpack_require__, 87448));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(87448)
            ];
        }
    },
    ssr: false
});
var StyledButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
    componentId: "sc-cdc854fa-0"
})(_templateObject());
var FlexRow = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-cdc854fa-1"
})(_templateObject1(), function(param) {
    var active = param.active;
    return active ? "#FAD436" : "#fff";
}, function(param) {
    var isMobile = param.isMobile;
    return isMobile ? "5px 5px" : "5px 10px";
}, function(param) {
    var active = param.active;
    return active ? "#14162A" : "#fff";
});
var ChartView;
(function(ChartView) {
    ChartView[ChartView["LIQUIDITY"] = 0] = "LIQUIDITY";
    ChartView[ChartView["VOLUME"] = 1] = "VOLUME";
    ChartView[ChartView["PRICE"] = 2] = "PRICE";
})(ChartView || (ChartView = {}));
var ChartCard = function(param) {
    var variant = param.variant, chartData = param.chartData, tokenData = param.tokenData, tokenPriceData = param.tokenPriceData, showKline = param.showKline, KLineTime = param.KLineTime, pairId = param.pairId, poolData = param.poolData, setKLineTime = param.setKLineTime;
    var isDesktop = (0,useMatchBreakpoints/* default */.Z)().isDesktop;
    var isMobile = isDesktop === false;
    var ref = (0,react.useState)(ChartView.VOLUME), view = ref[0], setView = ref[1];
    var ref1 = (0,react.useState)((chartData === null || chartData === void 0 ? void 0 : chartData.length) ? (0,formatInfoNumbers/* formatAmount */.dN)(chartData[chartData.length - 1][view]) : 0), hoverValue = ref1[0], setHoverValue = ref1[1];
    // const [hoverValue, setHoverValue] = useState<number | undefined>(
    //   view !== ChartView.PRICE ? (chartData?.length ? formatAmount(chartData[chartData.length - 1][view]) : 0) :
    //     tokenPriceData?.length ? formatAmount(tokenPriceData[tokenPriceData.length - 1].open) : 0
    // )
    var ref2 = (0,react.useState)(), hoverDate = ref2[0], setHoverDate = ref2[1];
    var ref3 = (0,react.useState)(false), kLoading = ref3[0], setKLoading = ref3[1];
    var ref4 = (0,src/* useTranslation */.$G)(), t = ref4.t, locale = ref4.currentLanguage.locale;
    var ref5 = (0,react.useState)(false), loading = ref5[0], setLoading = ref5[1];
    var currentDate = new Date().toLocaleString(locale, {
        month: "short",
        year: "numeric",
        day: "numeric"
    });
    var formattedTvlData = (0,react.useMemo)(function() {
        if (chartData) {
            return chartData.map(function(day) {
                return {
                    time: (0,fromUnixTime/* default */.Z)(day.date),
                    value: day.liquidityUSD
                };
            });
        }
        return [];
    }, [
        chartData
    ]);
    var formattedVolumeData = (0,react.useMemo)(function() {
        if (chartData) {
            return chartData.map(function(day) {
                return {
                    time: (0,fromUnixTime/* default */.Z)(day.date),
                    value: day.volumeUSD
                };
            });
        }
        return [];
    }, [
        chartData
    ]);
    (0,react.useEffect)(function() {
        setLoading(true);
        if (chartData === null || chartData === void 0 ? void 0 : chartData.length) {
            setLoading(false);
        } else {
            setTimeout(function() {
                setLoading(false);
            }, 500);
        }
    }, [
        chartData
    ]);
    (0,react.useEffect)(function() {
        setKLoading(true);
        setTimeout(function() {
            setKLoading(false);
        }, 500);
    }, [
        tokenPriceData
    ]);
    var getLatestValueDisplay = function() {
        var valueToDisplay = null;
        // const { t } = useTranslation()
        if (hoverValue) {
            if (view === ChartView.PRICE) {
                valueToDisplay = (0,formatInfoNumbers/* formatNumber */.uf)((0,formatInfoNumbers/* formatPrice */.T4)(hoverValue), hoverValue);
            } else {
                valueToDisplay = (0,formatInfoNumbers/* formatAmount */.dN)(Number(hoverValue) || 0);
            }
        } else if (hoverValue === 0) {
            valueToDisplay = 0;
        } else if (view === ChartView.VOLUME && formattedVolumeData.length > 0) {
            var ref;
            valueToDisplay = (0,formatInfoNumbers/* formatAmount */.dN)((ref = formattedVolumeData[formattedVolumeData.length - 1]) === null || ref === void 0 ? void 0 : ref.value);
        } else if (view === ChartView.LIQUIDITY && formattedTvlData.length > 0) {
            var ref1;
            valueToDisplay = (0,formatInfoNumbers/* formatAmount */.dN)((ref1 = formattedTvlData[formattedTvlData.length - 1]) === null || ref1 === void 0 ? void 0 : ref1.value);
        } else if (view === ChartView.PRICE && tokenPriceData.length) {
            var ref2, ref3;
            valueToDisplay = (0,formatInfoNumbers/* formatNumber */.uf)((0,formatInfoNumbers/* formatPrice */.T4)((ref2 = tokenPriceData[tokenPriceData.length - 1]) === null || ref2 === void 0 ? void 0 : ref2.open), (ref3 = tokenPriceData[tokenPriceData.length - 1]) === null || ref3 === void 0 ? void 0 : ref3.open);
        }
        // console.log(valueToDisplay, 'valueToDisplay')
        return valueToDisplay ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
            fontSize: "24px",
            bold: true,
            children: [
                view === ChartView.PRICE ? " " : "$",
                valueToDisplay
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
            fontSize: "24px",
            bold: true,
            children: [
                view === ChartView.PRICE ? " " : "$",
                "0"
            ]
        });
    };
    (0,react.useEffect)(function() {
        // console.log(tokenPriceData[tokenPriceData.length - 1]?.open, '11111111111111')
        if (view === ChartView.PRICE) {
            var ref, ref1;
            setHoverValue((0,formatInfoNumbers/* formatNumber */.uf)((0,formatInfoNumbers/* formatPrice */.T4)((ref = tokenPriceData[tokenPriceData.length - 1]) === null || ref === void 0 ? void 0 : ref.open), (ref1 = tokenPriceData[tokenPriceData.length - 1]) === null || ref1 === void 0 ? void 0 : ref1.open));
        } else if (view === ChartView.VOLUME && formattedVolumeData.length > 0) {
            var ref2;
            setHoverValue((0,formatInfoNumbers/* formatAmount */.dN)((ref2 = formattedVolumeData[formattedVolumeData.length - 1]) === null || ref2 === void 0 ? void 0 : ref2.value));
        } else if (view === ChartView.LIQUIDITY && formattedTvlData.length > 0) {
            var ref3;
            setHoverValue((0,formatInfoNumbers/* formatAmount */.dN)((ref3 = formattedTvlData[formattedTvlData.length - 1]) === null || ref3 === void 0 ? void 0 : ref3.value));
        }
    }, [
        view,
        tokenPriceData
    ]);
    (0,react.useEffect)(function() {
        if (showKline) {
            setView(ChartView.PRICE);
        }
    }, [
        showKline
    ]);
    (0,react.useEffect)(function() {
        if (view === ChartView.PRICE && !hoverValue) {
            var ref, ref1;
            setHoverValue((0,formatInfoNumbers/* formatNumber */.uf)((0,formatInfoNumbers/* formatPrice */.T4)((ref = tokenPriceData[tokenPriceData.length - 1]) === null || ref === void 0 ? void 0 : ref.open), (ref1 = tokenPriceData[tokenPriceData.length - 1]) === null || ref1 === void 0 ? void 0 : ref1.open));
        }
    }, [
        hoverValue,
        view
    ]);
    var handleTab = function(id) {
        setKLineTime(id);
    };
    var tabArr = [
        {
            id: 6,
            label: t("noah480"),
            value: "minute5"
        },
        {
            id: 5,
            label: t("noah215"),
            value: "minute15"
        },
        {
            id: 4,
            label: t("noah214"),
            value: "hour"
        },
        {
            id: 0,
            label: t("noah197"),
            value: "hour4"
        },
        {
            id: 1,
            label: t("noah198"),
            value: "day"
        },
        {
            id: 2,
            label: t("noah199"),
            value: "week"
        },
        {
            id: 3,
            label: t("noah200"),
            value: "month"
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default */.Z, {
        style: {
            padding: 0,
            background: "#fff",
            height: isMobile ? "440px" : "auto"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                style: {
                    padding: isMobile ? "25px 16px 0" : "25px 30px 0"
                },
                children: [
                    showKline && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledButton, {
                        height: "32px",
                        variant: view === ChartView.PRICE ? "primary" : "text",
                        onClick: function() {
                            return setView(ChartView.PRICE);
                        },
                        children: t("noah81")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledButton, {
                        height: "32px",
                        variant: view === ChartView.VOLUME ? "primary" : "text",
                        onClick: function() {
                            return setView(ChartView.VOLUME);
                        },
                        children: t("noah107")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledButton, {
                        height: "32px",
                        variant: view === ChartView.LIQUIDITY ? "primary" : "text",
                        onClick: function() {
                            return setView(ChartView.LIQUIDITY);
                        },
                        children: t("noah37")
                    })
                ]
            }),
            !isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                justifyContent: "space-between",
                alignItems: "center",
                children: view !== ChartView.PRICE && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                    flexDirection: "column",
                    px: "24px",
                    pt: "24px",
                    children: [
                        hoverValue ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                            fontSize: "24px",
                            bold: true,
                            children: [
                                "$",
                                hoverValue
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            fontSize: "24px",
                            bold: true,
                            children: "$0"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            small: true,
                            color: "#000",
                            children: hoverDate || currentDate
                        })
                    ]
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                style: {
                    padding: "10px 16px"
                },
                children: view !== ChartView.PRICE && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                    flexDirection: "column",
                    pt: "10px",
                    children: [
                        hoverValue ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                            fontSize: "24px",
                            bold: true,
                            children: [
                                "$",
                                hoverValue
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            fontSize: "24px",
                            bold: true,
                            children: "$0"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            small: true,
                            color: "#000",
                            children: hoverDate || currentDate
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                px: !isMobile ? "24px" : "10px",
                height: view === ChartView.PRICE ? !isMobile ? "500px" : "300px" : !isMobile ? "calc(500px - 61px)" : "calc(360px - 61px)",
                style: {
                    marginTop: view === ChartView.PRICE ? !isMobile ? "20px" : "0" : "0"
                },
                children: view === ChartView.LIQUIDITY ? /*#__PURE__*/ (0,jsx_runtime.jsx)(LineChart/* default */.Z, {
                    data: formattedTvlData,
                    setHoverValue: setHoverValue,
                    setHoverDate: setHoverDate,
                    loading: loading
                }) : view === ChartView.VOLUME ? /*#__PURE__*/ (0,jsx_runtime.jsx)(BarChart/* default */.Z, {
                    data: formattedVolumeData,
                    setHoverValue: setHoverValue,
                    setHoverDate: setHoverDate,
                    loading: loading
                }) : view === ChartView.PRICE ? // <CandleChart
                //   data={tokenPriceData}
                //   setValue={setHoverValue}
                //   setLabel={setHoverDate}
                //   KLineTime={KLineTime}
                //   kLoading={kLoading}
                // />
                /*#__PURE__*/ (0,jsx_runtime.jsx)(KlineChart, {
                    data: tokenPriceData,
                    setValue: setHoverValue,
                    setLabel: setHoverDate,
                    poolData: poolData
                }) : null
            })
        ]
    });
};
/* harmony default export */ var InfoCharts_ChartCard = (ChartCard);

// EXTERNAL MODULE: ./src/views/Info/components/InfoTables/TransactionsTable.tsx + 1 modules
var TransactionsTable = __webpack_require__(66745);
// EXTERNAL MODULE: ./src/state/info/queries/pools/poolData.ts
var pools_poolData = __webpack_require__(71021);
// EXTERNAL MODULE: ./src/service/service.ts + 1 modules
var service = __webpack_require__(36141);
// EXTERNAL MODULE: ./src/service/chainUtils.ts
var chainUtils = __webpack_require__(99635);
// EXTERNAL MODULE: ./src/utils/formatBalance.ts
var formatBalance = __webpack_require__(65044);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/components/CopyButton/index.tsx
var CopyButton = __webpack_require__(57370);
;// CONCATENATED MODULE: ./src/views/Info/Pools/PoolPage.tsx
/* eslint-disable */ 


function PoolPage_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  grid-template-columns: 300px 1fr;\n  grid-gap: 1em;\n  margin-top: 16px;\n  @media screen and (max-width: 800px) {\n    grid-template-columns: 1fr;\n    grid-template-rows: 1fr 1fr;\n    display: flex;\n    flex-direction: column-reverse;\n  }\n"
    ]);
    PoolPage_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function PoolPage_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 16px 4px;\n  flex-direction: column;\n  gap: 8px;\n  margin-top: 8px;\n  border-radius: 16px;\n  // max-width: 280px;\n"
    ]);
    PoolPage_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 400;\n  font-size: 14px;\n  color: #000;\n  opacity: 1 !important;\n  border-width: 1px;\n  /* width: 100%; */\n  height: 40px;\n  padding: 0 10px;\n  width: 96%;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}




















var ContentLayout = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d108cb83-0"
})(PoolPage_templateObject());
var LockedTokensContainer = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-d108cb83-1"
})(PoolPage_templateObject1());
var PoolPage_StyledButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
    componentId: "sc-d108cb83-2"
})(_templateObject2());
var PoolPage = function(param) {
    var routeAddress = param.address;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25, ref26, ref27, ref28, ref29, ref30, ref31, ref32, ref33, ref34, ref35, ref36, ref37, ref38, ref39, ref40, ref41, ref42, ref43, ref44, ref45, ref46, ref47, ref48, ref49, ref50, ref51, ref52, ref53, ref54, ref55, ref56, ref57, ref58, ref59;
    var isDesktop = (0,useMatchBreakpoints/* default */.Z)().isDesktop;
    var isMobile = isDesktop === false;
    // const { t } = useTranslation()
    var ref60 = (0,src/* useTranslation */.$G)(), locale = ref60.currentLanguage.locale, t = ref60.t;
    var ref61 = (0,react.useState)(false), showKline = ref61[0], setShowKline = ref61[1];
    var router = (0,next_router.useRouter)();
    // const parsedQueryChainId = Number(router.query.chainId)
    // const chainId = parsedQueryChainId || Number(localStorage.getItem('chainId'))
    // In case somebody pastes checksummed address into url (since GraphQL expects lowercase address)
    var address = routeAddress.toLowerCase();
    var ref62 = (0,react.useState)({
        address: "",
        token0: {
            address: "",
            name: "",
            symbol: ""
        },
        token1: {
            address: "",
            name: "",
            symbol: ""
        }
    }), poolData = ref62[0], setPoolData = ref62[1];
    // fetch data for unfetched pools and update them
    var ref63 = (0,pools_poolData/* default */.Z)(address, true), poolDataError = ref63.error, poolDatas = ref63.data;
    (0,react.useEffect)(function() {
        if (poolDatas && !poolDataError) {
            if (Object.keys(poolDatas).length === 1) {
                setPoolData(poolDatas[address]);
            // console.log('更新了poolDatas', poolDatas)
            }
        }
    }, [
        poolDataError,
        poolDatas,
        address
    ]);
    // debugger
    var chartData = (0,hooks/* usePoolChartData */.lR)(address);
    var ref64 = (0,react.useState)([]), tokenPriceData = ref64[0], setTokenPriceData = ref64[1];
    var ref65 = (0,react.useState)(1), type = ref65[0], setType = ref65[1];
    var ref66 = (0,react.useState)([]), transactions = ref66[0], setTransactions = ref66[1];
    var ref67 = (0,react.useState)(false), loading = ref67[0], setLoading = ref67[1];
    var ref68 // 默认取15分钟数据, 原赋值minute15, 现改为15
     = (0,react.useState)("15"), KLineTime = ref68[0], setKLineTime = ref68[1];
    var ref69 = (0,react.useState)(true), isDivVisible = ref69[0], setDivVisible = ref69[1];
    var reinitializePageRef = (0,react.useRef)(true);
    // 判断是否有k线
    (0,react.useEffect)(function() {
        var ref = (0,chainUtils/* default */.Z)(), baseURL = ref.baseURL, chainid = ref.chainid;
        var fetch = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function() {
                var params, ref, data, code;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            params = {
                                pairId: address
                            };
                            return [
                                4,
                                (0,service/* getKlinePairs */.hg)(params, {
                                    baseURL: baseURL,
                                    chainid: chainid
                                })
                            ];
                        case 1:
                            ref = _state.sent(), data = ref.data, code = ref.code;
                            if (!code) {
                                if ((data === null || data === void 0 ? void 0 : data.length) > 0) {
                                    setShowKline(true);
                                } else {
                                    setShowKline(false);
                                }
                            }
                            return [
                                2
                            ];
                    }
                });
            });
            return function fetch() {
                return _ref.apply(this, arguments);
            };
        }();
        fetch();
    }, [
        address,
        showKline
    ]);
    // kline data 暂时注释
    // useEffect(() => {
    //   let uri = ''
    //   const env = process.env.NODE_ENV
    //   // if (chainId === 15557) {
    //   //   if (process.env.NODE_ENV === 'development') {
    //   //     uri = 'ws://192.168.50.2:10078'
    //   //   } else {
    //   //     uri = 'wss://testapi.noahark.pro/aws'
    //   //   }
    //   // } else {
    //   // uri = 'wss://api.noahark.pro/aws'
    //   // }
    //   // uri = process.env.NODE_ENV === 'development' ? 'ws://192.168.50.2:10078' : 'wss://api.noahark.io/aws'
    //   uri = 'wss://api.noahark.io/aws'
    //   // if (reinitializePageRef.current === true) {
    //   const client = new CFClient({ env, uri, debug: false })
    //   // }
    //   if (KLineTime) {
    //     Io.cfwsUnsubscribe(客户)
    //   }
    //   if (address && poolData?.token0.address && showKline && KLineTime) {
    //     const params = {
    //       resolution: KLineTime,
    //       symbol: poolData?.token0.address,
    //       pairId: address,
    //       from: 1672502400,
    //       to: Math.floor(Date.now() / 1000),
    //     }
    //     Io.cfwsKline(client, params, KLineTime, true, (response, way) => {
    //       // reinitializePageRef.current = false
    //       // console.log(response.klines, 'responseresponseresponse.klines')
    //       setTokenPriceData([])
    //       if (way === 'all') {
    //         if (response.klines.length === 0) {
    //           // callback && callback({ s: 'no_data' })
    //           setTokenPriceData([])
    //         } else {
    //           const bars = []
    //           // eslint-disable-next-line no-restricted-syntax
    //           for (const element of response.klines) {
    //             const barTime = element.time / 1000
    //             if (barTime >= 1672502400 && barTime <= Math.floor(Date.now() / 1000)) {
    //               bars.push(element)
    //             }
    //           }
    //           bars.sort((l, r) => (l.time > r.time ? 1 : -1))
    //           setTokenPriceData(bars)
    //         }
    //       } else {
    //         // console.log(response, 'responseresponse')
    //         // const listenerGUID = `${symbol.toLowerCase()}_${this.resolution.toLowerCase()}`;
    //         // const _listenerGUID = listenerGUID.replace('+', '_');
    //         // console.log(_listenerGUID);
    //         // const realtimeCallback = this.realtimeCallback[_listenerGUID];
    //         // if (typeof realtimeCallback === 'function') {
    //         //   realtimeCallback(response.klines[0]);
    //         // }
    //       }
    //     })
    //     Io.cfwsUnsubscribe(client)
    //   }
    //   // return () => { Io.cfwsUnsubscribe(client) }
    // }, [address, poolData?.token0, showKline, KLineTime])
    // info页面交易记录
    var timer;
    var fetchData = function(param) {
        var baseURL = param.baseURL, chainid = param.chainid;
        // setLoading(true)
        timer = clearTimeout(timer);
        //
        var fetch = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function() {
                var params, datas, ref, code, data, ref1, e;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            params = {
                                type: type,
                                currPage: 1,
                                pageSize: 100,
                                pairId: address
                            };
                            datas = [];
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                (0,service/* getRecords */.Q6)(params, {
                                    baseURL: baseURL,
                                    chainid: chainid
                                })
                            ];
                        case 2:
                            ref = _state.sent(), code = ref.code, data = ref.data;
                            if (!code) {
                                ;
                                datas = (ref1 = data === null || data === void 0 ? void 0 : data.map(function(v) {
                                    return {
                                        type: params.type,
                                        direction: v.direction,
                                        amountToken0: v.count0,
                                        amountToken1: v.count1,
                                        token0Symbol: v.symbol0,
                                        token1Symbol: v.symbol1,
                                        timestamp: new Date(v.block_time).getTime() / 1000,
                                        pair: v.pair_id,
                                        hash: v.trx_id,
                                        sender: v.owner,
                                        amountUSD: v.operate_usd
                                    };
                                })) === null || ref1 === void 0 ? void 0 : ref1.sort(function(a, b) {
                                    return parseInt(b.timestamp, 10) - parseInt(a.timestamp, 10);
                                });
                            } else {
                                datas = [];
                            }
                            return [
                                3,
                                4
                            ];
                        case 3:
                            e = _state.sent();
                            datas = [];
                            return [
                                3,
                                4
                            ];
                        case 4:
                            if (datas) {
                                setTransactions(datas);
                            }
                            return [
                                2
                            ];
                    }
                });
            // setTimeout(() => {
            //   setLoading(false)
            // }, 500);
            });
            return function fetch() {
                return _ref.apply(this, arguments);
            };
        }();
        fetch();
        timer = setTimeout(function() {
            fetchData({
                baseURL: baseURL,
                chainid: chainid
            });
        }, 10000);
    };
    (0,react.useEffect)(function() {
        var ref = (0,chainUtils/* default */.Z)(), baseURL = ref.baseURL, chainid = ref.chainid;
        fetchData({
            baseURL: baseURL,
            chainid: chainid
        });
        return function() {
            clearTimeout(timer);
        };
    }, [
        type,
        address
    ]);
    var symbolChange = {
        token0: poolData === null || poolData === void 0 ? void 0 : poolData.token0,
        token1: poolData === null || poolData === void 0 ? void 0 : poolData.token1
    };
    if ((poolData === null || poolData === void 0 ? void 0 : poolData.direction) === 1) {
        symbolChange = {
            token0: poolData === null || poolData === void 0 ? void 0 : poolData.token1,
            token1: poolData === null || poolData === void 0 ? void 0 : poolData.token0
        };
    }
    var symbolArray = [
        "0xfA9343C3897324496A05fC75abeD6bAC29f8A40f",
        "0x922D641a426DcFFaeF11680e5358F34d97d112E1",
        "0xeFAeeE334F0Fd1712f9a8cc375f427D9Cdd40d73",
        "0x765277EebeCA2e31912C9946eAe1021199B39C61",
        "0x818ec0A7Fe18Ff94269904fCED6AE3DaE6d6dC0b",
        "0x461d52769884ca6235B685EF2040F47d30C94EB5", 
    ];
    // const symbolArr = ['DAI', 'USDT', 'USDC']
    // if (poolData?.token0?.symbol === 'WEOS' && !symbolArr.find((item) => item === poolData?.token1?.symbol)) {
    //   symbolChange = {
    //     token0: poolData?.token1,
    //     token1: poolData?.token0,
    //   }
    // }
    var handleCloseClick = function() {
        // console.log('ddsadsa')
        setDivVisible(false);
    };
    // console.log('poolData外', poolData)
    var priceChange = (poolData === null || poolData === void 0 ? void 0 : poolData.priceChange) > 0 ? "+".concat(poolData === null || poolData === void 0 ? void 0 : poolData.priceChange.toFixed(2)) : (poolData === null || poolData === void 0 ? void 0 : poolData.priceChange) === 0 ? "0.00" : "-".concat(Math.abs(poolData === null || poolData === void 0 ? void 0 : poolData.priceChange).toFixed(2));
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Page/* default */.Z, {
        symbol: poolData ? "".concat(poolData === null || poolData === void 0 ? void 0 : (ref = poolData.token0) === null || ref === void 0 ? void 0 : ref.symbol, " / ").concat(poolData === null || poolData === void 0 ? void 0 : (ref1 = poolData.token1) === null || ref1 === void 0 ? void 0 : ref1.symbol) : null,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        isDivVisible && (symbolArray.some(function(item) {
                            var ref;
                            return item.toLowerCase() === (poolData === null || poolData === void 0 ? void 0 : (ref = poolData.token0) === null || ref === void 0 ? void 0 : ref.address);
                        }) || symbolArray.some(function(item) {
                            var ref;
                            return item.toLowerCase() === (poolData === null || poolData === void 0 ? void 0 : (ref = poolData.token1) === null || ref === void 0 ? void 0 : ref.address);
                        })) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            style: {
                                background: "rgba(255, 255, 255, .38)",
                                fontSize: "14px",
                                lineHeight: "18px",
                                padding: "10px 10px 10px 10px",
                                borderRadius: "10px",
                                marginBottom: "15px",
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    style: {
                                        paddingRight: "10px"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: "/images/small-img/warning.png",
                                            alt: "",
                                            width: 20,
                                            style: {
                                                marginBottom: "-3px"
                                            }
                                        }),
                                        "\xa0",
                                        t("noah482")
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    style: {
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        cursor: "pointer"
                                    },
                                    onClick: handleCloseClick,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* default */.Z, {
                                        width: "24px",
                                        color: "#000"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                            children: [
                                (poolData === null || poolData === void 0 ? void 0 : poolData.direction) === 1 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    style: {
                                        display: "flex"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CurrencyLogo/* CurrencyLogo */.X, {
                                            address: poolData === null || poolData === void 0 ? void 0 : (ref2 = poolData.token1) === null || ref2 === void 0 ? void 0 : ref2.address,
                                            symbol: poolData === null || poolData === void 0 ? void 0 : (ref3 = poolData.token1) === null || ref3 === void 0 ? void 0 : ref3.symbol,
                                            size: "30px"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CurrencyLogo/* CurrencyLogo */.X, {
                                            address: poolData === null || poolData === void 0 ? void 0 : (ref4 = poolData.token0) === null || ref4 === void 0 ? void 0 : ref4.address,
                                            symbol: poolData === null || poolData === void 0 ? void 0 : (ref5 = poolData.token0) === null || ref5 === void 0 ? void 0 : ref5.symbol,
                                            size: "30px"
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    style: {
                                        display: "flex"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CurrencyLogo/* CurrencyLogo */.X, {
                                            address: poolData === null || poolData === void 0 ? void 0 : (ref6 = poolData.token0) === null || ref6 === void 0 ? void 0 : ref6.address,
                                            symbol: poolData === null || poolData === void 0 ? void 0 : (ref7 = poolData.token0) === null || ref7 === void 0 ? void 0 : ref7.symbol,
                                            size: "30px"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CurrencyLogo/* CurrencyLogo */.X, {
                                            address: poolData === null || poolData === void 0 ? void 0 : (ref8 = poolData.token1) === null || ref8 === void 0 ? void 0 : ref8.address,
                                            symbol: poolData === null || poolData === void 0 ? void 0 : (ref9 = poolData.token1) === null || ref9 === void 0 ? void 0 : ref9.symbol,
                                            size: "30px"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                    position: "relative",
                                    flexDirection: "column",
                                    style: {
                                        marginLeft: "6px",
                                        marginBottom: "10px"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            bold: true,
                                            ml: "5px",
                                            fontSize: "14px",
                                            lineHeight: "18px",
                                            children: (poolData === null || poolData === void 0 ? void 0 : poolData.direction) === 1 ? "".concat(poolData === null || poolData === void 0 ? void 0 : (ref10 = poolData.token1) === null || ref10 === void 0 ? void 0 : ref10.symbol, "/").concat(poolData === null || poolData === void 0 ? void 0 : (ref11 = poolData.token0) === null || ref11 === void 0 ? void 0 : ref11.symbol) : "".concat(poolData === null || poolData === void 0 ? void 0 : (ref12 = poolData.token0) === null || ref12 === void 0 ? void 0 : ref12.symbol, "/").concat(poolData === null || poolData === void 0 ? void 0 : (ref13 = poolData.token1) === null || ref13 === void 0 ? void 0 : ref13.symbol)
                                        }),
                                        (poolData === null || poolData === void 0 ? void 0 : poolData.direction) === 1 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                            alignItems: "center",
                                            style: {
                                                height: "16px",
                                                marginLeft: "4px"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CopyButton/* CopyButton */.q, {
                                                    width: "24px",
                                                    text: poolData === null || poolData === void 0 ? void 0 : (ref14 = poolData.token1) === null || ref14 === void 0 ? void 0 : ref14.address,
                                                    address: poolData === null || poolData === void 0 ? void 0 : (ref15 = poolData.token1) === null || ref15 === void 0 ? void 0 : ref15.address,
                                                    iconColor: true,
                                                    tooltipMessage: t("noah179"),
                                                    tooltipTop: 40,
                                                    tooltipRight: 120
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                    color: "#92929B",
                                                    mr: "10px",
                                                    fontSize: "12px",
                                                    children: "|"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CopyButton/* CopyButton */.q, {
                                                    width: "24px",
                                                    text: poolData === null || poolData === void 0 ? void 0 : (ref16 = poolData.token0) === null || ref16 === void 0 ? void 0 : ref16.address,
                                                    address: poolData === null || poolData === void 0 ? void 0 : (ref17 = poolData.token0) === null || ref17 === void 0 ? void 0 : ref17.address,
                                                    iconColor: true,
                                                    tooltipMessage: t("noah179"),
                                                    tooltipTop: 40,
                                                    tooltipRight: 0
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                            alignItems: "center",
                                            style: {
                                                height: "16px",
                                                marginLeft: "4px"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CopyButton/* CopyButton */.q, {
                                                    width: "24px",
                                                    text: poolData === null || poolData === void 0 ? void 0 : (ref18 = poolData.token0) === null || ref18 === void 0 ? void 0 : ref18.address,
                                                    address: poolData === null || poolData === void 0 ? void 0 : (ref19 = poolData.token0) === null || ref19 === void 0 ? void 0 : ref19.address,
                                                    iconColor: true,
                                                    tooltipMessage: t("noah179"),
                                                    tooltipTop: 40,
                                                    tooltipRight: 120
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                    color: "#92929B",
                                                    mr: "10px",
                                                    fontSize: "12px",
                                                    children: "|"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CopyButton/* CopyButton */.q, {
                                                    width: "24px",
                                                    text: poolData === null || poolData === void 0 ? void 0 : (ref20 = poolData.token1) === null || ref20 === void 0 ? void 0 : ref20.address,
                                                    address: poolData === null || poolData === void 0 ? void 0 : (ref21 = poolData.token1) === null || ref21 === void 0 ? void 0 : ref21.address,
                                                    iconColor: true,
                                                    tooltipMessage: t("noah179"),
                                                    tooltipTop: 40,
                                                    tooltipRight: 0
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                            justifyContent: "space-between",
                            mb: "16px",
                            flexDirection: [
                                "column",
                                "column",
                                "row"
                            ],
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                justifyContent: [
                                    null,
                                    null,
                                    "flex-end"
                                ],
                                mt: [
                                    "8px",
                                    "8px",
                                    0
                                ],
                                children: [
                                    (poolData === null || poolData === void 0 ? void 0 : (ref22 = poolData.token0) === null || ref22 === void 0 ? void 0 : ref22.address) && (poolData === null || poolData === void 0 ? void 0 : (ref23 = poolData.token1) === null || ref23 === void 0 ? void 0 : ref23.address) && /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* NextLinkFromReactRouter */.a, {
                                        to: "/add/".concat(poolData === null || poolData === void 0 ? void 0 : (ref24 = poolData.token0) === null || ref24 === void 0 ? void 0 : ref24.address, "/").concat(poolData === null || poolData === void 0 ? void 0 : (ref25 = poolData.token1) === null || ref25 === void 0 ? void 0 : ref25.address),
                                        style: {
                                            flex: 1
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PoolPage_StyledButton, {
                                            children: t("noah10")
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* NextLinkFromReactRouter */.a, {
                                        to: "/swap?inputCurrency=".concat(poolData === null || poolData === void 0 ? void 0 : poolData.token0.address, "&outputCurrency=").concat(poolData === null || poolData === void 0 ? void 0 : poolData.token1.address),
                                        style: {
                                            flex: 1
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PoolPage_StyledButton, {
                                            variant: "secondary",
                                            style: {
                                                borderColor: "#000"
                                            },
                                            children: t("noah80")
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkExternal/* default */.Z, {
                                        href: (0,utils/* getBlockExploreLink */.C)(address, "address"),
                                        showIcon: false,
                                        style: {
                                            flex: 1
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PoolPage_StyledButton, {
                                            variant: "secondary",
                                            style: {
                                                borderColor: "#000"
                                            },
                                            children: t("noah6")
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        isDivVisible && (symbolArray.some(function(item) {
                            var ref;
                            return item.toLowerCase() === (poolData === null || poolData === void 0 ? void 0 : (ref = poolData.token0) === null || ref === void 0 ? void 0 : ref.address);
                        }) || symbolArray.some(function(item) {
                            var ref;
                            return item.toLowerCase() === (poolData === null || poolData === void 0 ? void 0 : (ref = poolData.token1) === null || ref === void 0 ? void 0 : ref.address);
                        })) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            style: {
                                background: "rgba(255, 255, 255, .38)",
                                fontSize: "14px",
                                lineHeight: "18px",
                                padding: "10px 10px 10px 10px",
                                borderRadius: "10px",
                                marginBottom: "15px",
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    style: {
                                        paddingRight: "10px"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: "/images/small-img/warning.png",
                                            alt: "",
                                            width: 20,
                                            style: {
                                                marginBottom: "-3px"
                                            }
                                        }),
                                        "\xa0",
                                        t("noah482")
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    style: {
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        cursor: "pointer"
                                    },
                                    onClick: handleCloseClick,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* default */.Z, {
                                        width: "24px",
                                        color: "#000"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                            justifyContent: "space-between",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                    children: [
                                        (poolData === null || poolData === void 0 ? void 0 : poolData.direction) === 1 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CurrencyLogo/* CurrencyLogo */.X, {
                                                    address: poolData === null || poolData === void 0 ? void 0 : (ref26 = poolData.token1) === null || ref26 === void 0 ? void 0 : ref26.address,
                                                    symbol: poolData === null || poolData === void 0 ? void 0 : (ref27 = poolData.token1) === null || ref27 === void 0 ? void 0 : ref27.symbol,
                                                    size: "40px"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CurrencyLogo/* CurrencyLogo */.X, {
                                                    address: poolData === null || poolData === void 0 ? void 0 : (ref28 = poolData.token0) === null || ref28 === void 0 ? void 0 : ref28.address,
                                                    symbol: poolData === null || poolData === void 0 ? void 0 : (ref29 = poolData.token0) === null || ref29 === void 0 ? void 0 : ref29.symbol,
                                                    size: "40px"
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CurrencyLogo/* CurrencyLogo */.X, {
                                                    address: poolData === null || poolData === void 0 ? void 0 : (ref30 = poolData.token0) === null || ref30 === void 0 ? void 0 : ref30.address,
                                                    symbol: poolData === null || poolData === void 0 ? void 0 : (ref31 = poolData.token0) === null || ref31 === void 0 ? void 0 : ref31.symbol,
                                                    size: "40px"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CurrencyLogo/* CurrencyLogo */.X, {
                                                    address: poolData === null || poolData === void 0 ? void 0 : (ref32 = poolData.token1) === null || ref32 === void 0 ? void 0 : ref32.address,
                                                    symbol: poolData === null || poolData === void 0 ? void 0 : (ref33 = poolData.token1) === null || ref33 === void 0 ? void 0 : ref33.symbol,
                                                    size: "40px"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                            position: "relative",
                                            flexDirection: "column",
                                            style: {
                                                marginLeft: "6px"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                    bold: true,
                                                    ml: "5px",
                                                    fontSize: "16px",
                                                    lineHeight: "28px",
                                                    children: (poolData === null || poolData === void 0 ? void 0 : poolData.direction) === 1 ? "".concat(poolData === null || poolData === void 0 ? void 0 : (ref34 = poolData.token1) === null || ref34 === void 0 ? void 0 : ref34.symbol, " / ").concat(poolData === null || poolData === void 0 ? void 0 : (ref35 = poolData.token0) === null || ref35 === void 0 ? void 0 : ref35.symbol) : "".concat(poolData === null || poolData === void 0 ? void 0 : (ref36 = poolData.token0) === null || ref36 === void 0 ? void 0 : ref36.symbol, " / ").concat(poolData === null || poolData === void 0 ? void 0 : (ref37 = poolData.token1) === null || ref37 === void 0 ? void 0 : ref37.symbol)
                                                }),
                                                (poolData === null || poolData === void 0 ? void 0 : poolData.direction) === 1 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                                    alignItems: "center",
                                                    style: {
                                                        height: "14px",
                                                        marginLeft: "4px"
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CopyButton/* CopyButton */.q, {
                                                            width: "24px",
                                                            text: poolData === null || poolData === void 0 ? void 0 : (ref38 = poolData.token1) === null || ref38 === void 0 ? void 0 : ref38.address,
                                                            address: poolData === null || poolData === void 0 ? void 0 : (ref39 = poolData.token1) === null || ref39 === void 0 ? void 0 : ref39.address,
                                                            iconColor: true,
                                                            tooltipMessage: t("noah179"),
                                                            tooltipTop: 50,
                                                            tooltipRight: 120
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                            color: "#92929B",
                                                            mr: "10px",
                                                            fontSize: "12px",
                                                            children: "|"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CopyButton/* CopyButton */.q, {
                                                            width: "24px",
                                                            text: poolData === null || poolData === void 0 ? void 0 : (ref40 = poolData.token0) === null || ref40 === void 0 ? void 0 : ref40.address,
                                                            address: poolData === null || poolData === void 0 ? void 0 : (ref41 = poolData.token0) === null || ref41 === void 0 ? void 0 : ref41.address,
                                                            iconColor: true,
                                                            tooltipMessage: t("noah179"),
                                                            tooltipTop: 50,
                                                            tooltipRight: -20
                                                        })
                                                    ]
                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                                    alignItems: "center",
                                                    style: {
                                                        height: "14px",
                                                        marginLeft: "4px"
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CopyButton/* CopyButton */.q, {
                                                            width: "24px",
                                                            text: poolData === null || poolData === void 0 ? void 0 : (ref42 = poolData.token0) === null || ref42 === void 0 ? void 0 : ref42.address,
                                                            address: poolData === null || poolData === void 0 ? void 0 : (ref43 = poolData.token0) === null || ref43 === void 0 ? void 0 : ref43.address,
                                                            iconColor: true,
                                                            tooltipMessage: t("noah179"),
                                                            tooltipTop: 50,
                                                            tooltipRight: 120
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                            color: "#92929B",
                                                            mr: "10px",
                                                            fontSize: "12px",
                                                            children: "|"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CopyButton/* CopyButton */.q, {
                                                            width: "24px",
                                                            text: poolData === null || poolData === void 0 ? void 0 : (ref44 = poolData.token1) === null || ref44 === void 0 ? void 0 : ref44.address,
                                                            address: poolData === null || poolData === void 0 ? void 0 : (ref45 = poolData.token1) === null || ref45 === void 0 ? void 0 : ref45.address,
                                                            iconColor: true,
                                                            tooltipMessage: t("noah179"),
                                                            tooltipTop: 50,
                                                            tooltipRight: -20
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                    justifyContent: "space-between",
                                    alignSelf: "flex-end",
                                    children: [
                                        (poolData === null || poolData === void 0 ? void 0 : (ref46 = poolData.token0) === null || ref46 === void 0 ? void 0 : ref46.address) && (poolData === null || poolData === void 0 ? void 0 : (ref47 = poolData.token1) === null || ref47 === void 0 ? void 0 : ref47.address) && /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* NextLinkFromReactRouter */.a, {
                                            to: "/add/".concat(poolData === null || poolData === void 0 ? void 0 : (ref48 = poolData.token0) === null || ref48 === void 0 ? void 0 : ref48.address, "/").concat(poolData === null || poolData === void 0 ? void 0 : (ref49 = poolData.token1) === null || ref49 === void 0 ? void 0 : ref49.address),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PoolPage_StyledButton, {
                                                style: {
                                                    marginLeft: "10px"
                                                },
                                                children: t("noah10")
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* NextLinkFromReactRouter */.a, {
                                            to: "/swap?inputCurrency=".concat(poolData === null || poolData === void 0 ? void 0 : poolData.token0.address, "&outputCurrency=").concat(poolData === null || poolData === void 0 ? void 0 : poolData.token1.address),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PoolPage_StyledButton, {
                                                variant: "secondary",
                                                style: {
                                                    borderColor: "#000",
                                                    marginLeft: "12px"
                                                },
                                                children: t("noah80")
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkExternal/* default */.Z, {
                                            href: (0,utils/* getBlockExploreLink */.C)(address, "address"),
                                            showIcon: false,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PoolPage_StyledButton, {
                                                variant: "secondary",
                                                style: {
                                                    borderColor: "#000",
                                                    marginLeft: "15px"
                                                },
                                                children: t("noah6")
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentLayout, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
                                style: {
                                    background: "#fff",
                                    height: "100%"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                    p: "24px",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            style: {
                                                // borderBottom: '1px solid #F3F3F3',
                                                // paddingBottom: '20px',
                                                display: isMobile && "flex",
                                                justifyContent: "space-between"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                                            mb: "10px",
                                                            children: [
                                                                (poolData === null || poolData === void 0 ? void 0 : poolData.direction) === 1 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                                                    color: "#666666",
                                                                    fontSize: "12px",
                                                                    children: [
                                                                        t("noah81"),
                                                                        "(".concat(poolData === null || poolData === void 0 ? void 0 : (ref50 = poolData.token1) === null || ref50 === void 0 ? void 0 : ref50.symbol, "/").concat(poolData === null || poolData === void 0 ? void 0 : (ref51 = poolData.token0) === null || ref51 === void 0 ? void 0 : ref51.symbol, ")")
                                                                    ]
                                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                                                    color: "#666666",
                                                                    fontSize: "12px",
                                                                    children: [
                                                                        t("noah81"),
                                                                        "(".concat(poolData === null || poolData === void 0 ? void 0 : (ref52 = poolData.token0) === null || ref52 === void 0 ? void 0 : ref52.symbol, "/").concat(poolData === null || poolData === void 0 ? void 0 : (ref53 = poolData.token1) === null || ref53 === void 0 ? void 0 : ref53.symbol, ")")
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                                                    alignItems: "center",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                                            fontSize: "18px",
                                                                            mr: "5px",
                                                                            children: (0,formatInfoNumbers/* formatNumber */.uf)((0,formatInfoNumbers/* formatPrice */.T4)(poolData === null || poolData === void 0 ? void 0 : poolData.price), poolData === null || poolData === void 0 ? void 0 : poolData.price)
                                                                        }),
                                                                        (poolData === null || poolData === void 0 ? void 0 : poolData.priceUsd) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                                                            fontSize: "12px",
                                                                            color: "#92929B",
                                                                            children: [
                                                                                "$",
                                                                                (0,formatInfoNumbers/* formatNumber */.uf)((0,formatInfoNumbers/* formatUsd */.gC)(poolData === null || poolData === void 0 ? void 0 : poolData.priceUsd), poolData === null || poolData === void 0 ? void 0 : poolData.priceUsd)
                                                                            ]
                                                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                                            fontSize: "12px",
                                                                            color: "#92929B",
                                                                            children: "\xa0"
                                                                        }),
                                                                        priceChange && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                                                            color: (poolData === null || poolData === void 0 ? void 0 : poolData.priceChange) > 0 ? "green" : (poolData === null || poolData === void 0 ? void 0 : poolData.priceChange) < 0 ? "red" : "",
                                                                            textAlign: "right",
                                                                            style: {
                                                                                fontWeight: "bold"
                                                                            },
                                                                            children: [
                                                                                "\xa0\xa0",
                                                                                priceChange,
                                                                                "%"
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                                            mb: "10px",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                                    color: "#666666",
                                                                    fontSize: "12px",
                                                                    children: t("noah82")
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                                                        fontSize: "18px",
                                                                        mr: "10px",
                                                                        children: [
                                                                            "$",
                                                                            (0,formatInfoNumbers/* formatAmount */.dN)(poolData === null || poolData === void 0 ? void 0 : poolData.volumeUSD)
                                                                        ]
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    style: {
                                                        width: "115px"
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                                            mb: "10px",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                                    color: "#666666",
                                                                    fontSize: "12px",
                                                                    children: t("noah83")
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                                                    fontSize: "18px",
                                                                    mr: "10px",
                                                                    children: [
                                                                        "$",
                                                                        (0,formatInfoNumbers/* formatAmount */.dN)(poolData === null || poolData === void 0 ? void 0 : poolData.totalFees24h)
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                                            mb: "10px",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                                    color: "#666666",
                                                                    fontSize: "12px",
                                                                    children: t("noah84")
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                                                    fontSize: "18px",
                                                                    mr: "10px",
                                                                    children: [
                                                                        (0,formatInfoNumbers/* formatAmount */.dN)((poolData === null || poolData === void 0 ? void 0 : poolData.lpApr7d) * 100),
                                                                        "%"
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            style: {
                                                borderBottom: "1px solid #F3F3F3",
                                                paddingBottom: "20px"
                                            },
                                            children: (poolData === null || poolData === void 0 ? void 0 : poolData.isFarm) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                                    mb: "10px",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                                            color: "#666666",
                                                            fontSize: "12px",
                                                            children: [
                                                                t("noah281"),
                                                                locale !== "zh-TW" && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    children: "\xa0"
                                                                }),
                                                                t("noah288")
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                            fontSize: "18px",
                                                            mr: "10px",
                                                            children: (poolData === null || poolData === void 0 ? void 0 : poolData.farm_total_yield) - (poolData === null || poolData === void 0 ? void 0 : poolData.farm_fee_yield) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                href: "/farms",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    style: {
                                                                        cursor: "pointer"
                                                                    },
                                                                    children: [
                                                                        Number((0,formatBalance/* truncateZero */.bW)(((poolData === null || poolData === void 0 ? void 0 : poolData.farm_total_yield) - (poolData === null || poolData === void 0 ? void 0 : poolData.farm_fee_yield)) * 100, 2)) > 100000 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                            children: ">100000%"
                                                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                            children: [
                                                                                (0,formatBalance/* truncateZero */.bW)(((poolData === null || poolData === void 0 ? void 0 : poolData.farm_total_yield) - (poolData === null || poolData === void 0 ? void 0 : poolData.farm_fee_yield)) * 100, 2),
                                                                                "%"
                                                                            ]
                                                                        }),
                                                                        " ",
                                                                        (poolData === null || poolData === void 0 ? void 0 : poolData.farm_total_yield_high) - (poolData === null || poolData === void 0 ? void 0 : poolData.farm_fee_yield) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                            children: "~ "
                                                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {}),
                                                                        Number((0,formatBalance/* truncateZero */.bW)(((poolData === null || poolData === void 0 ? void 0 : poolData.farm_total_yield_high) - (poolData === null || poolData === void 0 ? void 0 : poolData.farm_fee_yield)) * 100, 2)) > 200000 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                            children: ">200000%"
                                                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                            children: (poolData === null || poolData === void 0 ? void 0 : poolData.farm_total_yield_high) - (poolData === null || poolData === void 0 ? void 0 : poolData.farm_fee_yield) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                                children: [
                                                                                    (0,formatBalance/* truncateZero */.bW)(((poolData === null || poolData === void 0 ? void 0 : poolData.farm_total_yield_high) - (poolData === null || poolData === void 0 ? void 0 : poolData.farm_fee_yield)) * 100, 2),
                                                                                    "%"
                                                                                ]
                                                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {})
                                                                        })
                                                                    ]
                                                                })
                                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                children: "-"
                                                            })
                                                        })
                                                    ]
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            color: "#666666",
                                            mt: "24px",
                                            fontSize: "12px",
                                            children: t("noah108")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(LockedTokensContainer, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                                    justifyContent: "space-between",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CurrencyLogo/* CurrencyLogo */.X, {
                                                                    address: poolData === null || poolData === void 0 ? void 0 : (ref54 = poolData.token0) === null || ref54 === void 0 ? void 0 : ref54.address,
                                                                    symbol: poolData === null || poolData === void 0 ? void 0 : (ref55 = poolData.token0) === null || ref55 === void 0 ? void 0 : ref55.symbol,
                                                                    size: "24px"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                                    small: true,
                                                                    color: "textSubtle",
                                                                    ml: "8px",
                                                                    children: poolData === null || poolData === void 0 ? void 0 : (ref56 = poolData.token0) === null || ref56 === void 0 ? void 0 : ref56.symbol
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                            small: true,
                                                            width: isMobile ? 110 : "",
                                                            children: (0,formatInfoNumbers/* formatAmount */.dN)(poolData === null || poolData === void 0 ? void 0 : poolData.liquidityToken0)
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                                    justifyContent: "space-between",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CurrencyLogo/* CurrencyLogo */.X, {
                                                                    address: poolData === null || poolData === void 0 ? void 0 : (ref57 = poolData.token1) === null || ref57 === void 0 ? void 0 : ref57.address,
                                                                    symbol: poolData === null || poolData === void 0 ? void 0 : (ref58 = poolData.token1) === null || ref58 === void 0 ? void 0 : ref58.symbol,
                                                                    size: "24px"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                                    small: true,
                                                                    color: "textSubtle",
                                                                    ml: "8px",
                                                                    children: poolData === null || poolData === void 0 ? void 0 : (ref59 = poolData.token1) === null || ref59 === void 0 ? void 0 : ref59.symbol
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                            small: true,
                                                            width: isMobile ? 110 : "",
                                                            children: (0,formatInfoNumbers/* formatAmount */.dN)(poolData === null || poolData === void 0 ? void 0 : poolData.liquidityToken1)
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoCharts_ChartCard, {
                            variant: "pool",
                            chartData: chartData,
                            tokenPriceData: tokenPriceData,
                            KLineTime: KLineTime,
                            setKLineTime: setKLineTime,
                            showKline: showKline,
                            pairId: address,
                            poolData: poolData
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                    mb: "16px",
                    mt: "16px",
                    scale: "lg"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TransactionsTable/* default */.Z, {
                    transactions: transactions,
                    setType: setType,
                    type: type,
                    loading: loading
                })
            ]
        })
    });
};
/* harmony default export */ var Pools_PoolPage = (PoolPage);

;// CONCATENATED MODULE: ./src/pages/info/pools/[address].tsx
/* eslint-disable */ 



var _address_PoolPage = function() {
    var router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Pools_PoolPage, {
        address: String(router.query.address)
    });
};
_address_PoolPage.Layout = Info/* InfoPageLayout */.O;
/* harmony default export */ var _address_ = (_address_PoolPage);


/***/ }),

/***/ 60764:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "X": function() { return /* binding */ CurrencyLogo; },
  "g": function() { return /* binding */ DoubleCurrencyLogo; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/hooks/useActiveWeb3React.ts
var useActiveWeb3React = __webpack_require__(64011);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(94589);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
;// CONCATENATED MODULE: ./src/views/Info/components/CurrencyLogo/LogoLoader.tsx





var BAD_SRCS = [];
/**
 * Renders an image by sequentially trying a list of URIs, and then eventually a fallback to HelpIcon
 */ var LogoLoader = function(_param) {
    var src = _param.src, alt = _param.alt, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "src",
        "alt"
    ]);
    var ref = (0,react.useState)(0), refresh = ref[1];
    var srcFailedLoading = BAD_SRCS.includes(src);
    if (src && !srcFailedLoading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, rest), {
            alt: alt,
            src: src,
            onError: function() {
                if (src) BAD_SRCS.push(src);
                refresh(function(i) {
                    return i + 1;
                });
            }
        }));
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, rest), {
        src: "/images/small-img/default-icon.png",
        alt: ""
    }));
// return <HelpIcon {...rest} />
};
/* harmony default export */ var CurrencyLogo_LogoLoader = (LogoLoader);

;// CONCATENATED MODULE: ./src/views/Info/components/CurrencyLogo/index.tsx
/* eslint-disable */ 


function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  width: ",
        ";\n  height: ",
        ";\n  border-radius: ",
        ";\n  /* box-shadow: 0px 6px 10px rgba(0, 0, 0, 0.075); */\n  background-color: ",
        ";\n  color: ",
        ";\n  margin-right: ",
        ";\n  z-index: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  width: 32px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}





var StyledLogo = (0,styled_components_browser_esm/* default */.ZP)(CurrencyLogo_LogoLoader).withConfig({
    componentId: "sc-1182136a-0"
})(_templateObject(), function(param) {
    var size = param.size;
    return size;
}, function(param) {
    var size = param.size;
    return size;
}, function(param) {
    var size = param.size;
    return size;
}, function(param) {
    var theme = param.theme;
    return theme.colors.background;
}, function(param) {
    var theme = param.theme;
    return theme.colors.text;
}, function(param) {
    var firstimg = param.firstimg;
    return firstimg && "-6px";
}, function(param) {
    var firstimg = param.firstimg;
    return firstimg ? "4" : "3";
});
var CurrencyLogo = function(_param) {
    var address = _param.address, symbol = _param.symbol, _size = _param.size, size = _size === void 0 ? "24px" : _size, _firstimg = _param.firstimg, firstimg = _firstimg === void 0 ? "false" : _firstimg, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "address",
        "symbol",
        "size",
        "firstimg"
    ]);
    var chainId = (0,useActiveWeb3React/* default */.Z)().chainId;
    var src = (0,react.useMemo)(function() {
        // const checksummedAddress = isAddress(address)
        if (address && symbol) {
            // return `https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/${checksummedAddress}/logo.png`
            // return `https://s3.ap-southeast-1.amazonaws.com/noahark.pro/image/${chainId}-${address.toLowerCase()}-${symbol.toLowerCase()}.png`
            return "https://s3.ap-northeast-1.amazonaws.com/1noahark.io/image/".concat(chainId, "-").concat(address.toLowerCase(), "-").concat(symbol.toLowerCase(), ".png");
        }
        return null;
    }, [
        address,
        symbol,
        chainId
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLogo, (0,_object_spread/* default */.Z)({
        size: size,
        src: src,
        alt: "token logo",
        firstimg: firstimg
    }, rest));
};
var DoubleCurrencyWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1182136a-1"
})(_templateObject1());
var DoubleCurrencyLogo = function(param) {
    var token0 = param.token0, token1 = param.token1, _size = param.size, size = _size === void 0 ? 16 : _size;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(DoubleCurrencyWrapper, {
        children: [
            (token0 === null || token0 === void 0 ? void 0 : token0.address) && (token0 === null || token0 === void 0 ? void 0 : token0.symbol) && /*#__PURE__*/ (0,jsx_runtime.jsx)(CurrencyLogo, {
                address: token0 === null || token0 === void 0 ? void 0 : token0.address,
                symbol: token0 === null || token0 === void 0 ? void 0 : token0.symbol,
                size: "".concat(size.toString(), "px"),
                firstimg: "true"
            }),
            (token1 === null || token1 === void 0 ? void 0 : token1.address) && (token1 === null || token1 === void 0 ? void 0 : token1.symbol) && /*#__PURE__*/ (0,jsx_runtime.jsx)(CurrencyLogo, {
                address: token1 === null || token1 === void 0 ? void 0 : token1.address,
                symbol: token1 === null || token1 === void 0 ? void 0 : token1.symbol,
                size: "".concat(size.toString(), "px")
            })
        ]
    });
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4885,2077,8747,1895,322,9774,2888,179], function() { return __webpack_exec__(20133); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);